import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { PagedResponse } from '@core/models/models';
import {
  Grupo,
  GrupoFiltro,
  RoleDoGrupo,
} from '@admin/feactures-modules/permissoes/permissao.model';

/** Endpoints de gestão de grupos e respetivas permissões. */
@Injectable({ providedIn: 'root' })
export class PermissaoService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiurl}/api/Auth`;

  listarGrupos(filtro: GrupoFiltro): Observable<PagedResponse<Grupo>> {
    let params = new HttpParams()
      .set('pageNumber', String(filtro.pageNumber))
      .set('pageSize', String(filtro.pageSize));
    if (filtro.nomePesquisa) {
      params = params.set('nomePesquisa', filtro.nomePesquisa);
    }
    return this.http.get<PagedResponse<Grupo>>(`${this.baseUrl}/ListarGrupo`, {
      params,
    });
  }

  criarGrupo(nomeGrupo: string): Observable<any> {
    const params = new HttpParams().set('nomeGrupo', nomeGrupo);
    return this.http.post<any>(`${this.baseUrl}/CriarGrupo`, null, { params });
  }

  editarGrupo(grupoId: string, nomeGrupo: string): Observable<any> {
    const params = new HttpParams().set('nomeGrupo', nomeGrupo);
    return this.http.put<any>(
      `${this.baseUrl}/EditarGrupo/${encodeURIComponent(grupoId)}`,
      null,
      { params },
    );
  }

  eliminarGrupo(grupoId: string): Observable<any> {
    return this.http.delete<any>(
      `${this.baseUrl}/EliminarGrupo/${encodeURIComponent(grupoId)}`,
    );
  }

  /**
   * GET /api/Auth/ListarPermissao/{grupoId}
   * Devolve as roles do grupo com o guid necessário para RemoverRoleDoGrupo.
   */
  listarPermissoesDoGrupo(grupoId: string): Observable<PagedResponse<RoleDoGrupo>> {
    const params = new HttpParams()
      .set('pageNumber', '1')
      .set('pageSize', '100');
    return this.http.get<PagedResponse<RoleDoGrupo>>(
      `${this.baseUrl}/ListarPermissao/${encodeURIComponent(grupoId)}`,
      { params },
    );
  }

  adicionarRoleAoGrupo(groupId: string, roleEnum: number): Observable<any> {
    const url = `${this.baseUrl}/AdicionarRoleAoGrupo/${encodeURIComponent(groupId)}/${encodeURIComponent(String(roleEnum))}`;
    return this.http.post<any>(url, null);
  }

  removerRoleDoGrupo(groupId: string, roleId: string): Observable<any> {
    const url = `${this.baseUrl}/RemoverRoleDoGrupo/${encodeURIComponent(groupId)}/${encodeURIComponent(roleId)}`;
    return this.http.delete<any>(url);
  }

  adicionarUtilizadorAoGrupo(
    utilizadorId: number,
    grupoId: string,
  ): Observable<any> {
    const url = `${this.baseUrl}/AdicionarUtilizadorDoGrupo/${encodeURIComponent(String(utilizadorId))}/${encodeURIComponent(grupoId)}`;
    return this.http.post<any>(url, null);
  }

  removerUtilizadorDoGrupo(
    utilizadorId: number,
    grupoId: string,
  ): Observable<any> {
    const url = `${this.baseUrl}/RemoverUtilizadorDoGrupo/${encodeURIComponent(String(utilizadorId))}/${encodeURIComponent(grupoId)}`;
    return this.http.delete<any>(url);
  }
}
